// extracted by mini-css-extract-plugin
export default {"form":"formStyle_form__-Z0zV","button":"formStyle_button__vIOfH","tos":"formStyle_tos__l-9Lr"};